const ModalContainer = () => {
  return (
    <div id="modal-root"></div>
  )
}

export default ModalContainer